import { type ReactNode } from 'react';
import { ComingSoonSection } from './coming-soon-section';

// /team/approachers. El rol aún no tiene pantalla propia, así que reutiliza
// el ComingSoonSection que vivía dentro de /team antes del hub (DEBOOK-1902).
export function ApproachersPage(): ReactNode {
  return <ComingSoonSection role="approacher" />;
}
